import React from "react";
import { Form, Input, Button, message, Card } from "antd";
import { LockOutlined } from "@ant-design/icons";
import { useNavigate } from "react-router-dom";
import axiosInstance from "../../interceptor/interceptor";
import ChangePassImg from "../../assets/resetPass.png"; 

// const { Title } = Typography;

const ChangePasswordForm = () => {
  const navigate = useNavigate();

  const onFinish = async (values) => {
    const userData = localStorage.getItem("user");

    if (!userData) {
      message.error("User data not found in localStorage. Please log in again.");
      return;
    }

    const parsedData = JSON.parse(userData);
    const empno = parsedData.empno;

    if (!empno) {
      message.error("Employee number not found. Please log in again.");
      return;
    }

    const { currentPassword, newPassword } = values;

    try {
       await axiosInstance.post("auth/update-password", {
        empno,
        currentPassword,
        newPassword,
      });

      message.success("Password changed successfully!");
      navigate("/dashboard");
    } catch (error) {
      if (error.response) {
        message.error(error.response.data.message || "Password change failed. Please try again.");
      } else {
        message.error("Network error. Please try again later.");
      }
    }
  };

  const handleCancel = () => {
    navigate("/dashboard");
  };

  return (
    <div className="login-container"> {/* Reuse login-container */}
      <div className="login"> {/* Reuse login */}
        <div className="login-grid"> {/* Reuse login-grid */}
          <div className="login-image-container"> {/* Reuse login-image-container */}
            <img src={ChangePassImg} alt="Change Password" className="login-image" />
          </div>
          <div className="login-form-container"> {/* Reuse login-form-container */}
            <div className="form-wrapper"> {/* Reuse form-wrapper */}
             
              <Card
                title="Change Password"
                style={{ width: 400, borderRadius: "8px" }}
              >
                <Form
                  name="changePassword"
                  onFinish={onFinish}
                  layout="vertical"
                >
                  <Form.Item
                    label="Current Password"
                    name="currentPassword"
                    rules={[{ required: true, message: "Please input your current password!" }]}
                  >
                    <Input.Password
                      prefix={<LockOutlined />}
                      placeholder="Enter your current password"
                    />
                  </Form.Item>

                  <Form.Item
                    label="New Password"
                    name="newPassword"
                    rules={[{ required: true, message: "Please input your new password!" }]}
                  >
                    <Input.Password
                      prefix={<LockOutlined />}
                      placeholder="Enter your new password"
                    />
                  </Form.Item>

                  <Form.Item
                    label="Confirm New Password"
                    name="confirmPassword"
                    dependencies={["newPassword"]}
                    rules={[
                      { required: true, message: "Please confirm your new password!" },
                      ({ getFieldValue }) => ({
                        validator(_, value) {
                          if (!value || getFieldValue("newPassword") === value) {
                            return Promise.resolve();
                          }
                          return Promise.reject(new Error("The passwords do not match!"));
                        },
                      }),
                    ]}
                  >
                    <Input.Password
                      prefix={<LockOutlined />}
                      placeholder="Confirm your new password"
                    />
                  </Form.Item>

                  <Form.Item>
                    <Button type="primary" htmlType="submit" className="blue-button" block>
                      Change Password
                    </Button>
                  </Form.Item>

                  <Form.Item>
                    <Button onClick={handleCancel} className="red-button" block>
                      Cancel
                    </Button>
                  </Form.Item>
                </Form>
              </Card>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ChangePasswordForm;
